import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Iso8601Pipe } from './iso8601.pipe';



@NgModule({
  declarations: [Iso8601Pipe],
  exports: [Iso8601Pipe],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
